import React, { useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useHistory } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';
import { loggerSipEnableSystem, loggerSipDownloadSystem, accessLocalStorage } from '../../services';

import '../../libs/bulma.min.css';
import './LogsVigoscloud.css';

const ipGetRequest = window.location.href;
const myIP = ipGetRequest.split('/')[2].includes(':') ? ipGetRequest.split('/')[2].split(':')[0] : ipGetRequest.split('/')[2];

const socket = io(`//${myIP}`, { 
  path: "/io/",
  withCredentials: true
});
socket.on('connection-vigoscloud', (evt) => evt)

function LogsVigoscloud() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden } = getItensStateGlobal;

  const history = useHistory();

  let url = window.location.href;
  url = url.split('/')[2];

  const [ logs, setlogs ] = useState([]);
  const [ pause, setPause ] = useState(true);
  const [ enableSipButton, setEnableSipButton ] = useState(true);
  const [ enableDownloadBotton, setEnableDownloadBotton ] = useState(true);
  const [ pid, setPid ] = useState(null);

  if (pause) socket.disconnect();
  if (!pause) socket.connect();
  
  const handleDownloadLog = async () => {
    try {
      const response = await loggerSipDownloadSystem();
      
      if (response.status !== 200) {
        setMessage(response.data?.message || "Erro ao fazer download.");
        return;
      }
      
      // Cria o blob e o URL a partir do blob
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      
      // Cria um link e dispara o download
      const link = document.createElement('a');
      link.href = url;
      link.download = 'logs-sip-vigoscloud.pcap';
      
      // (Opcional) Insere o link no DOM para melhor compatibilidade
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Revoga o objeto URL após o uso
      window.URL.revokeObjectURL(url);
      
      // Se necessário, recarrega a página após 5 segundos
      setTimeout(() => window.location.reload(), 5000);
      
    } catch (error) {
      setMessage("Erro ao fazer download.");
      console.error("Erro no download do log:", error);
    }
  };

  const enableMonitorLogs = (value) => {
    setPause(value);
    setEnableSipButton(value)
    toggleIsHidden('#enable-logs');
    toggleIsHidden('#disable-logs');
  };

  const handleChangeLogsSip = async (state) => {
    const sendCommand = await loggerSipEnableSystem({ statusSip: state });
    if (state === 'off') setEnableDownloadBotton(false);
    toggleIsHidden('#enable-sip-logs');
    toggleIsHidden('#disable-sip-logs');
  };

  const verifyIsUserTec = () => {
    const user = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = user;
    if (role !== 'root') return history.push('/home');
  };

  useEffect(() => {
    socket.on('log', (data) => {
      setlogs((prevState) => {
        if (prevState.length < 12) {
          return [...prevState, data]
        } else {
          prevState.shift();
          return [...prevState, data]
        }
      });
    });
  }, [socket, pause]);

  useEffect(() => {
    verifyIsUserTec();
  }, []);

  return (
    <div className="logs-vigoscloud-container">
      <div className="logs-vigoscloud-header">
        <div className="logs-vigoscloud-title-wrapper">
          <svg className="logs-vigoscloud-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h1 className="logs-vigoscloud-title">VIGOSCLOUD LOGS</h1>
        </div>
      </div>

      <article className="logs-card">
        <div className="logs-card-header">
          <p className="logs-card-title">LOGS</p>
          <div className="logs-controls">
            <button className="btn-log-control btn-log-on" id="enable-logs" type="submit" onClick={ () => enableMonitorLogs(false) }>
              <span>Logs ON</span>
            </button>
            <button className="btn-log-control btn-log-off is-hidden" id="disable-logs" type="submit" onClick={ () => enableMonitorLogs(true) }>
              <span>Logs OFF</span>
            </button>
            <button className="btn-log-control btn-log-download" id="download-sip-logs" type="submit" onClick={ () => handleDownloadLog()} disabled={ enableDownloadBotton }>
              <span>Download</span>
            </button>
            <button className="btn-log-control btn-sip-on" id="enable-sip-logs" type="submit" onClick={ () => handleChangeLogsSip('on') } disabled={ enableSipButton }>
              <span>SIP ON</span>
            </button>
            <button className="btn-log-control btn-sip-off is-hidden" id="disable-sip-logs" type="submit" onClick={ () => handleChangeLogsSip('off') }>
              <span>SIP OFF</span>
            </button>
          </div>
        </div>
        <div className="logs-card-body">
          <pre className="logs-display">
            { logs.length === 0 ? (
              <div className="logs-empty-state">Aguardando logs...</div>
            ) : (
              logs.map((item, index) => <p key={index}>{ item }</p>)
            )}
          </pre>
        </div>
      </article>
    </div>
  );
}

export default LogsVigoscloud;
